import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import messages from './messages';

import { showToast } from '../../components/toast/actions';
import {
    getDefaultCourse,
    getMasterCourserequest,
    updateTopicTreeRequest,
    publishCourse,
    saveCourse,
    cancelValidationErrorsRequest,
    closeAlertModal,
    openAlertModal,
    setCourseCreatorAsModified,
    setCourseCreatorAsClean,
    hideToastRequest,
    showPublishModal
} from './actions';

import { COURSE_CREATOR_SUB_ROUTES } from '../../constants';

import withLoader from '../../components/with-loader';

import CourseEditor from '../../components/course-creator/index';
import LinkedCourseModal from '../../components/linked-course-modal';

/**
 * ENUMS
 */
const {
    EDIT,
    COPY,
    CLONE
} = COURSE_CREATOR_SUB_ROUTES;

class CourseCreator extends Component {
    constructor(props) {
        super(props);
        const {
            match: {
                params: {
                    actionType
                }
            }
        } = this.props;

        this.state = {
            showLinkedCourseModal: false
        };

        this.isEdit = actionType === EDIT;
        this.isCopy = actionType === COPY;
        this.isClone = actionType === CLONE;

        this.publishCourse = this.publishCourse.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    static propTypes = {
        cancelValidationErrorsRequest: PropTypes.func,
        courseId: PropTypes.number,
        getDefaultCourse: PropTypes.func,
        getMasterCourserequest: PropTypes.func,
        getMasterCoursesByCountry: PropTypes.func,
        hideToastRequest: PropTypes.func,
        intl: intlShape.isRequired,
        isValidationError: PropTypes.bool,
        location: PropTypes.object.isRequired,
        masterCourse: PropTypes.object,
        match: PropTypes.object.isRequired,
        publishCourse: PropTypes.func,
        saveCourse: PropTypes.func,
        selectedProductId: PropTypes.number,
        showSuccessSaveMessage: PropTypes.bool,
        showToast: PropTypes.func,
        updateTopicTreeRequest: PropTypes.func,
        validationMessage: PropTypes.string
    };

    static defaultProps = {
        selectedCourse: {},
        standardFilters: {}
    };

    componentDidMount() {
        const {
            match: {
                params: {
                    masterCourseId,
                    version,
                    productId,
                    defaultCourseId
                }
            }
        } = this.props;

        // We intercept 3p courses 'Copy or Edit' with LinkedCourseModal to update Master Course
        if (this.isCopy || this.isEdit) {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                showLinkedCourseModal: true
            });
        }

        if (this.isClone) {
            this.props.getMasterCourserequest(masterCourseId, version);
        }

        if (this.isCopy || this.isEdit) {
            this.props.getDefaultCourse(productId, defaultCourseId, version);
        }

        if (!this.isCopy && !this.isEdit) {
            this.props.cancelValidationErrorsRequest();
        }
    }

    componentWillReceiveProps(props) {
        const {
            isValidationError,
            showSuccessSaveMessage
        } = props;

        if (isValidationError) {
            this.props.showToast(props.validationMessage, 'error');
        }

        if (showSuccessSaveMessage) {
            this.props.showToast(this.props.intl.formatMessage(messages.courseSaveSuccessMessage), 'success');
        }
    }

    updateTopicTree = (request) => {
        this.props.updateTopicTreeRequest(request);
    };

    publishCourse = (courseId, productId) => {
        this.props.publishCourse(courseId, productId, this.context);
    };

    handleOnBack = () => {
        this.props.cancelValidationErrorsRequest();
        this.context.router.history.goBack();
    }

    saveCourse = (request) => {
        if (!this.isEdit) {
            request.courseId = 0;
        }
        if (request.name !== '' && request.productId !== -1 && request.yearGroups.length > 0 && request.topics.length > 0) {
            this.props.saveCourse(request);
        } else if (request.topics.length === 0) {
            this.props.showToast(this.props.intl.formatMessage(messages.emptyTopicsValidationMessage), 'error');
        } else if (request.yearGroups.length === 0) {
            this.props.showToast(this.props.intl.formatMessage(messages.emptyYearValidationMessage), 'error');
        } else if (request.productId === -1) {
            this.props.showToast(this.props.intl.formatMessage(messages.productNameSelectionMessage), 'error');
        } else {
            this.props.showToast(this.props.intl.formatMessage(messages.courseNameEmptyMessage), 'error');
        }
    };

    render() {
        const {
            match,
            masterCourse
        } = this.props;
        const { showLinkedCourseModal } = this.state;

        return (
            <div>
                <LinkedCourseModal
                    hideModal={() => this.setState({
                        showLinkedCourseModal: false
                    })}
                    match={match}
                    selectedMasterCourse={masterCourse}
                    show={showLinkedCourseModal}
                />
                <CourseEditor
                    {...this.props}
                    handleOnback={this.handleOnBack}
                    handleOnCreateTopic={this.updateTopicTree}
                    handleOnTopicUpdate={this.updateTopicTree}
                    isDefaultCourse={this.isEdit || this.isCopy}
                    publishCourse={this.publishCourse}
                    saveCourse={this.saveCourse}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        masterCourse: state.courseCreator.masterCourse,
        genericCourse: state.courseCreator.genericCourse,
        pppCourse: state.courseCreator.pppCourse,
        assignedSpineItems: state.courseCreator.assignedSpineItems,
        topicTree: state.courseCreator.topicTree,
        hasLoader: state.courseCreator.isSaving || state.courseCreator.isPublishing,
        enableSaveCourse: state.courseCreator.enableSaveCourse,
        enablePublish: state.courseCreator.enablePublish,
        courseId: state.courseCreator.courseId,
        isValidationError: state.courseCreator.isValidationError,
        showSuccessSaveMessage: state.courseCreator.showSuccessSaveMessage,
        isAlertVisible: state.courseCreator.isAlertVisible,
        isDirty: state.courseCreator.courseCreatorIsModified,
        validationMessage: state.courseCreator.validationMessage,
        isFetched: state.courseCreator.isFetched,
        selectedProductId: state.courseCreator.productId,
        standardFilters: state.courseCreator.standardFilters,
        curriculumLevelDescriptions: state.courseCreator.curriculumLevelDescriptions,
        topicTypes: state.courseCreator.topicTypes,
        isPublishModalVisible: state.courseCreator.isPublishModalVisible
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMasterCourserequest,
        getDefaultCourse,
        updateTopicTreeRequest,
        publishCourse,
        saveCourse,
        showToast,
        cancelValidationErrorsRequest,
        closeAlertModal,
        openAlertModal,
        setCourseCreatorAsModified,
        setCourseCreatorAsClean,
        hideToastRequest,
        showPublishModal
    }, dispatch);
}
const CourseCreatorWithLoader = withLoader('hasLoader')(CourseCreator);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CourseCreatorWithLoader));



// WEBPACK FOOTER //
// ./app/containers/course-creator/index.js